import {Component, Input} from '@angular/core';
import {DialogService} from '@rbaip/ui-component';
import {Asset, ASSET_STATUS_LOT_PULLED, ASSET_STATUS_CLOSED} from '../../shared/domain/item';
import {appConfig} from '../../shared/app.config';
import {ItemSummaryRbaItemInfoService} from '../../shared/asset/item-summary-rba-item-info.service';

@Component({
  selector: 'lib-item-summary-asset-rb-details',
  templateUrl: './asset-rb-details.component.html',
  styleUrls: ['./asset-rb-details.component.scss']
})
export class AssetRbDetailsComponent {

  @Input() asset: Asset;
  public ASSET_STATUS_LOT_PULLED = ASSET_STATUS_LOT_PULLED;
  public ASSET_STATUS_CLOSED = ASSET_STATUS_CLOSED;

  constructor(private rbaItemInfoService: ItemSummaryRbaItemInfoService,
              private dialogService: DialogService) {
  }

  public openRbAuctionSite(): void {
    if ( this.asset.assetGuid ) {
      const assetGuid: string = this.asset.assetGuid.toString();
      this.rbaItemInfoService.getRBItemInfo(assetGuid).subscribe( rbItemInfo => {
        const rbLink: string = this.asset.getRBLink(rbItemInfo);
        if ( rbLink ) {
          window.open(appConfig.getRbAuctionPageUrl() + rbLink , '_blank');
        } else {
          this.dialogService.showMessage(this.asset.getRBErrorMessage(rbItemInfo));
        }
      });
    }
  }

  public openIronPlanetSite(): void {
    if ( this.asset.equipId ) {
      window.open(this.asset.getIPLink(), '_blank');
    }
  }

  public openGovPlanetSite():void{
    if ( this.asset.equipId ){
      window.open(this.asset.getGOVLink(), '_blank');
    }
  }

  public openSalvageSaleSite():void{
    if ( this.asset.equipId ){
      window.open(this.asset.getSalvageSaleLink(), '_blank');
    }
  }

  public displayTooltipMessage(): string {
    let response: string;
    if ( this.isRbaMissingInformation() ) {
      response = 'Asset RB information incomplete';
    }
    return response;
  }

  public isRbaMissingInformation(): boolean {
    return !!!this.asset.assetGuid;
  }

}
